/**
 * Browser extension error patterns
 * These errors are generated by browser extensions (Chrome/Firefox/etc) running on user machines,
 * not by our application code. We filter these out in Sentry to keep error tracking clean.
 */
export const BrowserError = {
	/** Chrome/Firefox extension runtime.sendMessage() calls that fail due to closed tabs or invalid contexts */
	RUNTIME_SEND_MESSAGE: /runtime\.sendMessage/i,

	/** Chrome extension error when a tab is closed or no longer exists */
	TAB_NOT_FOUND: /Tab not found/i,

	/** Extension context becomes invalid during navigation or extension updates */
	EXTENSION_CONTEXT_INVALIDATED: /Extension context invalidated/i,

	/** General Chrome extension runtime API errors */
	CHROME_RUNTIME: /chrome\.runtime/i,

	/** General Firefox extension runtime API errors */
	BROWSER_RUNTIME: /browser\.runtime/i,

	/** Chrome extension errors related to missing or invalidated extension IDs */
	EXTENSION_ID_ERROR: /Extension.*does not exist/i,

	/** Errors from extensions trying to access content scripts after navigation */
	CONTENT_SCRIPT_ERROR:
		/Could not establish connection\. Receiving end does not exist/i,

	/** Extension trying to send cross-extension messages with invalid extensionID */
	INVALID_EXTENSION_ID: /extensionID.*value is invalid/i,

	/** Microsoft Outlook SafeLinks crawler injects a broken update() shim and triggers this on any visited page */
	SAFELINKS_CRAWLER:
		/Object Not Found Matching Id:\d+, MethodName:.*, ParamCount:\d+/i,

	/** DuckDuckGo browser's built-in tracker protection script (e.g. `pageObserver`, `hover` features) */
	DUCKDUCKGO_FEATURE: /feature named `[^`]+` was not found/i,

	/** DuckDuckGo Mobile iOS in-app browser tears down WKWebView frame before JS injection completes */
	WKWEBVIEW_TARGET_FRAME: /Target frame could not be found/i,

	/** Zarget / Freshmarketer A/B testing / personalization script loaded by third parties */
	ZARGET_SCRIPT: /zarget|zargetMain|makeGeoRequest/i,
} as const
